import * as style from 'ol/style';

export const userPositionStyle = new style.Style({
    image: new style.Circle({
        fill: new style.Fill({
            color: '#3399CC',
        }),
        radius: 6,
        stroke: new style.Stroke({
            color: '#fff',
            width: 2,
        }),
    }),
});
